import {useEffect} from "react";

export default function useAsyncEffect(method: () => void, deps: any[] = []) {
    useEffect(() => {
        method();
    }, deps);
}